import type { AbsolutePath, Entity, EntityType, ValidatorType } from "shelving";
import { ArraySchema, ENTITY, EntitySchema, isArrayItem, splitEntity } from "shelving";

// Named entities.
export const TRAJECTORY_ENTITY: CreatorEntity = "group:trajectory";
export const TAG_ENTITY: CreatorEntity = "group:tags";
export const HELP_ENTITY: CreatorEntity = "group:help";
export const CREATORS_ENTITY: CreatorEntity = "group:creators";

/** Get the URL path for an entity tag. */
export function getEntityPath(entity: Entity): AbsolutePath {
	const [type, id] = splitEntity(entity);
	return `/${type}/${id}`;
}

/** A list of entities. */
export const ENTITIES = new ArraySchema({ items: ENTITY });

/** Creator entity is either a profile or a group. */
export const CREATOR_TYPES = ["profile", "group"] as const;
export const CREATOR_ENTITY = new EntitySchema({ title: "Creator", types: CREATOR_TYPES });
export type CreatorEntity = ValidatorType<typeof CREATOR_ENTITY>;
export type CreatorType = EntityType<CreatorEntity>;
export const isCreatorType = (type: string | undefined): type is CreatorType => isArrayItem(CREATOR_TYPES, type);

/** Content entity is any type of content a creator can create. */
export const CONTENT_TYPES = ["challenge", "reward", "note", "list", "post", "comment", "message"] as const;
export const CONTENT_ENTITY = new EntitySchema({ title: "Content", types: CONTENT_TYPES });
export type ContentEntity = ValidatorType<typeof CONTENT_ENTITY>;
export type ContentType = EntityType<ContentEntity>;
export const isContentType = (type: string | undefined): type is ContentType => isArrayItem(CONTENT_TYPES, type);

/** These entity types have a `.verified` field that specifies whether that content has been verified by Trajectory or not. */
export const VERIFIABLE_TYPES = ["group", "profile", "challenge", "reward"] as const;
export type VerifiableType = (typeof VERIFIABLE_TYPES)[number];
export const isVerifiableType = (type: string | undefined): type is VerifiableType => isArrayItem(VERIFIABLE_TYPES, type);
